import { SpaceBetween } from '@cloudscape-design/components';
import { Link } from '@cloudscape-design/components';
import { formatDateString } from '../common/formatting/dateFormat';
import { PlaceContactSmall } from '../common/types';
import { formatPhoneNumber } from '../common/formatting/phoneFormat';
import { useMemo } from 'react';
import { PhoneNumber } from './PhoneNumber';

export type PlaceContactsListProps = {
  contacts: PlaceContactSmall[];
  showLineTypeInfo?: boolean;
};

export function PlaceContactsList(props: PlaceContactsListProps) {
  const { contacts } = props;

  const items = useMemo(() => {
    const items: PlaceContactSmall[] = [];
    for (const contact of contacts) {
      if (contact.hidden) {
        continue;
      }
      if (contact.phone_number || contact.email) {
        items.push(contact);
      }
    }
    items.sort((a, b) => {
      return (b.date ? new Date(b.date).getTime() : 0) - (a.date ? new Date(a.date).getTime() : 0);
    });
    return items;
  }, [contacts]);

  return (
    <SpaceBetween size="xxs" direction="vertical">
      {items.map((contact) => {
        if (props.showLineTypeInfo && contact.phone_number) {
          return (
            <SpaceBetween size="xxxs" direction="vertical" key={contact.uuid}>
              <Link href={`/dashboard/contacts/${contact.uuid}`} variant="secondary" target="_blank">
                {contact.first_name} {contact.last_name}
              </Link>
              <PhoneNumber
                phoneNumber={contact.phone_number}
                lineTypeInfo={contact.phone_line_type_info}
                showLineTypeInfo
              />
              {contact.date ? `(${formatDateString(contact.date)})` : ''}
            </SpaceBetween>
          );
        }

        return (
          <Link
            key={contact.uuid}
            href={`/dashboard/contacts/${contact.uuid}`}
            variant="secondary"
            target="_blank"
            // onFollow={(e) => {
            //   e.preventDefault();
            //   navigate(`/contacts/${contact.uuid}`);
            // }}
          >
            {contact.first_name} {contact.last_name}:{' '}
            {contact.phone_number
              ? formatPhoneNumber(contact.phone_number)
              : contact.email
                ? contact.email
                : '-'}
            {contact.date ? ` (${formatDateString(contact.date)})` : ''}
          </Link>
        );
      })}
    </SpaceBetween>
  );
}
